import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import GlobalLevelList from '@/types/Levels/GlobalLevelList';
let BenefitsAddLevelModal = class BenefitsAddLevelModal extends Vue {
    addLevelFromDialog() {
        //we re-add these values here instead as they will be overwritten by the select otherwise
        console.log(this.$data.levelToAdd);
        this.$store.dispatch('saveBenefitLevel', { level: this.$data.levelToAdd, userId: this.$props.employee.userId, keepLevelHourProgress: this.$data.keepLevelHourProgress }).then((result) => {
            //this.loadUserLevels();
            this.$store.dispatch('ToastMessage', { type: 'any', message: 'Level added' });
            this.$emit('close');
            //send reload event
            window.eventBus.$emit('reloadBenefitsForUser');
        }).catch((err) => {
            window.errorHandler.logError(err, 'components/BenefitsAddLevelModal.vue - addLevelFromDialog');
        });
    }
};
BenefitsAddLevelModal = __decorate([
    Component({
        data() {
            return {
                keepLevelHourProgress: true,
                trueVal: true,
                levelToAdd: { from: '', workpercentage: 100 },
                theme: this.$store.getters.getTheme,
                globalLevels: null, //the list with all levels that exist 
            };
        },
        props: ['employee', 'prevLevel'],
        mounted() {
            // console.log(this.$props.prevLevel);
            this.$store.dispatch('loadGlobalLevelsAsnyc').then((response) => {
                const globalLevels = new GlobalLevelList();
                console.log(response.data);
                globalLevels.convertObjectsFromJson(response.data);
                globalLevels.levels.sort((a, b) => (Number(a.order) > Number(b.order)) ? 1 : -1);
                this.$data.globalLevels = globalLevels;
            }).catch((err) => {
                window.errorHandler.logError(err, 'components/Benefits/BenefitAddLevelModal.vue - loadGlobalLevels');
            });
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit('close'); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                }
            },
        },
        methods: {
            close() {
                this.$emit('close');
            }
        },
        components: {
            DatePickerTextbox,
        }
    })
], BenefitsAddLevelModal);
export default BenefitsAddLevelModal;
